export default "__VITE_ASSET__75fdb0bb__"